/**
 * 最多保留两位小数
 *  num: 值
 *  saveLength：保留几位小数
 */
const formatDecimal = (num: number | string, saveLength: number) => {
  if (!num === undefined) return
  // 将输入转换为字符串
  let _num = num.toString()
  // 匹配小数部分
  const decimalMatch = _num.match(/\.(\d+)/)

  // 如果有小数部分
  if (decimalMatch) {
    // eslint-disable-next-line prefer-destructuring
    let decimalPart = decimalMatch[1]

    // 如果小数位数大于2，则截取前两位
    if (decimalPart.length > saveLength) {
      decimalPart = decimalPart.substring(0, saveLength)
    }
    // 替换原来的小数部分
    _num = _num.replace(/\.\d+/, "." + decimalPart)
  }

  return _num
}

/**
 * 判断多少位小数点
 *  num: 值
 *  showZero：展示0
 *  thousandths： 是否格式化千分位
 */

const autoReplenishPoint = (
  num,
  showZero?,
  thousandths?,
  hideDecimalsWhenInteger = false, // 整数不显示小数.00
) => {
  if (num === undefined) return
  let _value = num
  // 转换成字符串形式
  const numStr = num.toString()
  // 查找小数点后的数字部分
  const match = numStr.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)
  // 如果没有小数点则返回0，如果有则返回小数点后的数字位数
  if (!match) return 0
  // 获取小数部分
  const decimalPart = match[1] || ""
  if (
    !hideDecimalsWhenInteger &&
    decimalPart?.length === 0 &&
    num !== "0" &&
    num &&
    !numStr?.includes(".")
  ) {
    _value += ".00"
  } else if (
    decimalPart?.length === 0 &&
    num !== "0" &&
    num &&
    numStr?.includes(".")
  ) {
    _value += "00"
  } else if (decimalPart?.length === 1 && num !== "0" && num) {
    _value += "0"
  } else if (!numStr && numStr !== "0" && showZero) {
    _value = ""
  } else if (numStr && numStr === "0" && showZero) {
    _value = "0.00"
  } else if (num === "0" || !num) {
    _value = ""
  }

  if (thousandths) {
    return _value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  // 返回小数部分的长度
  return _value
}

/**
 * 自动补充小数点数
 * value: 值
 * decimalPlaces：保留小数位数
 */

const completeDecimal = (value, decimalPlaces) => {
  const num = parseFloat(value)
  if (isNaN(num)) return "0." + "0".repeat(decimalPlaces)
  return num.toFixed(decimalPlaces)
}

const formatThousandths = (val) => {
  if (!val) return val
  return val?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function isDecimal(num) {
  return /^-?\d+\.\d+$/.test(num)
}

/**
 * 千分位格式化
 * value: 值
 */
const formatDisplayNumber = (value) => {
  const num = Number(value)
  if (isNaN(num)) return value.toString()
  return num.toLocaleString(
    "en-US",
    isDecimal(num)
      ? {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      : {},
  )
}

/**
 * 套餐价格展示：最多两位小数，省略末尾 0（如 49.00 → 49，49.50 → 49.5）
 */
const formatPlanPrice = (value: number | string) => {
  const num = Number(value)
  if (isNaN(num)) return String(value)
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

export {
  autoReplenishPoint,
  completeDecimal,
  formatDecimal,
  formatDisplayNumber,
  formatPlanPrice,
  formatThousandths,
}
